
<app-titledescription [title]="'Asignación De Títulos'" [description]="'Aca se podran asignar títulos a la persona ingresada'"></app-titledescription>

<!-- Filtro por DNI -->
<ng-template #filterTitulo class="flex">
  <app-input class="py-4" [label]="'Ingrese Dni'" [type]="'number'" (inputValue)="onDniInput($event)"></app-input>
  <div class="py-6">
    <app-button class="mr-2" [text]="'Buscar'" [typeButton]="'button'" (click)="dni ? searchTitulos() : null"></app-button>
  </div>
</ng-template>

<!-- Tabla de títulos de la persona -->
<ng-template #tableTitulos>
  @if(titulosByDniData){
    <h1 class="text-xl mb-2 text-gray-700 bg-gray-300 rounded-lg text-center p-1">
      Títulos Portal
    </h1>
    <div class="container">
      <app-table [columnsNames]="columnNamesTitulosUsuario" [dataFetch]="titulosUsuarioByDniData"
        [totalItems]="titulosUsuarioByDniData.total_items"  [pagination]="true" (callCustomFunction)="openModal($event)" (fetchAgain)="getTitulosPortalByDni($event.options, $event.ignoreCache)" [apiService]="tituloUsuarioService"></app-table>
    </div>
    <h1 class="text-xl mb-2 text-gray-700 bg-gray-300 rounded-lg text-center p-1">
      Títulos Media
    </h1>
    <div class="container">
      <app-table [columnsNames]="columnNamesTitulos" [dataFetch]="titulosByDniData"
        [totalItems]="titulosByDniData.total_items"  (callCustomFunction)="openModal($event)" (fetchAgain)="getAllTitulos($event.options, $event.ignoreCache)" [apiService]="tituloService"></app-table>
    </div>
  }
</ng-template>
<!-- Bloque para asignar títulos -->
<ng-template #asignarTitulos>
     @if(titulosByDniData){
     <mat-accordion class="example-headers-align asignar-titulos-accordion">
       <mat-expansion-panel hideToggle>
         <mat-expansion-panel-header>
           <mat-panel-title>
             <h1 class="text-md text-white">Asignar Nuevos Títulos</h1>
           </mat-panel-title>
           <mat-panel-description class="flex justify-between">
             <span>{{ panelOpenState() ? 'Click para cerrar' : 'Click para expandir' }}</span>
             <div class="flex items-center gap-2">
               <mat-icon>{{ panelOpenState() ? 'expand_less' : 'expand_more' }}</mat-icon>
             </div>
           </mat-panel-description>
         </mat-expansion-panel-header>
         <mat-divider></mat-divider>
         <div class="flex mt-2 gap-4">
           <div class="w-64 flex-1 ...">
             <h1 class="mb-2 text-gray-700 bg-gray-300 rounded-lg text-center">
               Títulos a asignar
             </h1>
             <div class="table-container" style="position: relative;">
               <app-table
                 #titulosToAdd
                 [height]="'350px'"
                 [dataFetch]="allTitulosData"
                 [columnsNames]="columnNamesTitulosAgregar"
                 [totalItems]="allTitulosData.total_items"
                 (fetchAgain)="getAllTitulos($event.options, $event.ignoreCache)"
                 [clickable]="true"
                 [filterable]="true"
                 [labelFilter]="'Título'"
                 [dataSelect]="dataSelectNiveles"
                 (returnClickedRows)="getClickedRows($event)"
                 [apiService]="tituloService"
                 [mainFilterField]="'nivel_id'"
                 [pagination]="true"
                 [pageSize]="50"
               ></app-table>
             </div>
           </div>
           <div class="w-32 flex-1 ...">
             <h1 class="text-xl mb-2 text-gray-700 bg-gray-300 rounded-lg text-center">
               Títulos asignados
             </h1>
             <mat-list role="list">
               <app-table
                 #titulosAdded
                 [height]="'350px'"
                 [columnsNames]="columnNamesTitulosAgregar"
                 [dataFetch]="dataAddTitulos"
                 [totalItems]="dataAddTitulos.total_items"
                 (returnClickedRows)="getClickedRows($event)"
                 (callCustomFunction)="deleteRow($event)"
                 [pagination]="false"
                 [apiService]="tituloService"
               ></app-table>
             </mat-list>
           </div>
         </div>
         @if(errorMessage){
           <div class="text-red-700 font-normal text-xs mt-2 ml-2">
             {{ errorMessage }}
           </div>
         }
         <mat-action-row>
           <app-button [text]="'Guardar'" (click)="submitForm()"></app-button>
           <app-button
             [text]="'Limpiar Todas'"
             [type]="'button'"
             [matButtonAparence]="'outlined'"
             (click)="clearAllTitulosAdded()"
           ></app-button>
         </mat-action-row>
       </mat-expansion-panel>
     </mat-accordion>
    }
   </ng-template>

<app-card [templateRefHeader]="filterTitulo" [templateRefContent]="tableTitulos" [templateRefFooter]="asignarTitulos"></app-card>
